import { render, staticRenderFns } from "./AccountDiameterGroupForm.vue?vue&type=template&id=027ef4d1&"
import script from "./AccountDiameterGroupForm.vue?vue&type=script&lang=js&"
export * from "./AccountDiameterGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports